(function () {
  'use strict';
  const loaderTag = document.currentScript;
  if (!loaderTag) return;
  let pending = null;
  let loaded = false;

  function scriptFrom(url) {
    return new Promise((resolve, reject) => {
      const el = document.createElement('script');
      el.src = url;
      el.async = false;
      el.onload = resolve;
      el.onerror = () => reject(new Error('Wishlist module could not load'));
      document.head.appendChild(el);
    });
  }

  function snapshot() {
    try {
      const saved = JSON.parse(localStorage.getItem('bl_wishlist_boards_v1') || 'null');
      return saved && Array.isArray(saved.boards) ? saved.boards : [];
    } catch (_) { return []; }
  }

  function updateButtons() {
    const boards = snapshot();
    const seen = new Set();
    const products = new Set();
    boards.forEach((board) => (Array.isArray(board.items) ? board.items : []).forEach((item) => {
      if (!item || !item.handle) return;
      seen.add(item.handle + ':' + String(item.variantId || ''));
      products.add(item.handle);
    }));
    document.querySelectorAll('[data-bl-wishlist-count]').forEach((node) => {
      node.textContent = String(seen.size);
      node.hidden = !seen.size;
    });
    document.querySelectorAll('[data-bl-wishlist-trigger]').forEach((node) => {
      const active = products.has(node.dataset.handle);
      node.setAttribute('aria-pressed', String(active));
      node.title = active ? 'Manage saved boards' : 'Save to board';
    });
  }

  async function load() {
    if (loaded) return;
    if (pending) return pending;
    pending = (async () => {
      await scriptFrom(loaderTag.dataset.blWishlistCore);
      await scriptFrom(loaderTag.dataset.blWishlistAccountConfig);
      await scriptFrom(loaderTag.dataset.blWishlistAccount);
      if (document.readyState === 'loading') {
        await new Promise((resolve) => document.addEventListener('DOMContentLoaded', resolve, {once: true}));
      }
      loaded = true;
    })().catch((error) => {
      pending = null;
      console.warn('BLS Wishlist deferred initialization failed', error);
      throw error;
    });
    return pending;
  }

  function eagerInteraction(event) {
    if (loaded || !event.target || !event.target.closest) return;
    if (event.target.closest('[data-bl-wishlist-trigger]')) load().catch(() => {});
  }

  document.addEventListener('pointerover', eagerInteraction, {passive: true});
  document.addEventListener('focusin', eagerInteraction);
  document.addEventListener('click', (event) => {
    if (loaded || !event.target || !event.target.closest) return;
    const button = event.target.closest('[data-bl-wishlist-trigger]');
    if (!button) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    load().then(() => { if (button.isConnected) button.click(); }).catch(() => {});
  }, true);

  document.addEventListener('shopify:section:load', updateButtons);
  window.addEventListener('storage', (event) => { if (event.key === 'bl_wishlist_boards_v1') updateButtons(); });
  updateButtons();

  let mustLoad = !!document.querySelector('[data-bl-wishlist-page]');
  try {
    mustLoad = mustLoad ||
      !!sessionStorage.getItem('bl_wl_session_v1') ||
      !!sessionStorage.getItem('bl_wl_pkce_v1') ||
      new URLSearchParams(location.search).has('code') ||
      new URLSearchParams(location.search).has('error');
  } catch (_) {}
  if (mustLoad) load().catch(() => {});
})();
